/**
 * AdvertisingPlatform
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { HttpFile } from '../http/http';

/**
* Global zip targeting configuration for StackAdapt campaign
*/
export class V3StackAdaptGlobalZipTargeting {
    /**
    * Country code for global zip targeting
    */
    'country'?: string;
    /**
    * List of zip codes for global zip targeting
    */
    'zipCodes'?: Array<string>;
    /**
    * Whether to include this global zip targeting
    */
    'inclusion'?: boolean;
    /**
    * Unique identifier for the global zip targeting
    */
    'id'?: string;

    static readonly discriminator: string | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "country",
            "baseName": "country",
            "type": "string",
            "format": ""
        },
        {
            "name": "zipCodes",
            "baseName": "zipCodes",
            "type": "Array<string>",
            "format": ""
        },
        {
            "name": "inclusion",
            "baseName": "inclusion",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "id",
            "baseName": "id",
            "type": "string",
            "format": ""
        }    ];

    static getAttributeTypeMap() {
        return V3StackAdaptGlobalZipTargeting.attributeTypeMap;
    }

    public constructor() {
    }
}

